export default function roleHelper($translate) {
  return { getLabel: getLabel };

  function getLabel(employeeRoleName) {
    var roleNameTranslated = $translate.instant('role.name.' + employeeRoleName);
    return roleNameTranslated !== 'role.name.' + employeeRoleName ? roleNameTranslated : employeeRoleName;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/roleHelper.helper.js